<template>
  <div class="config">
    <div class="innerBox" :class="{dark: darkmode}">
      <div class="contentWrapper">
        <h1>Configuration</h1>
        <!-- <h2>Rounding Up</h2>
        <AveInput :darkmode="darkmode" v-model="input" icon="roundingtime" placeholder="0:30h, 0.25 h, 5 min,..." :error="errorType"/> -->
        <h2>Manage tasks</h2>
        <!-- toggle disabled - is disabled if there is no done todo in database -->
        <!-- toggle type - switch between show / hide -->
        <AveButton :darkmode="darkmode" icon="task" v-show="type === true" icon-type="positive" label="Show finished tasks" @click="handleHide" />
        <AveButton :darkmode="darkmode" icon="task" v-show="type === false" icon-type="gray" label="Hide finished tasks" @click="handleHide" />
        <AveButton :darkmode="darkmode" icon="movetotrash" icon-type="negative" :disabled="disabled" label="Delete finished tasks" @click="handleDelete" />
        <h2>Information</h2>
        <AveButton :darkmode="darkmode" icon="information" icon-type="normal" label="Changelog" @click="openChangeLog" />
        <AveButton :darkmode="darkmode" icon="information" icon-type="normal" label="Privacy Policy" @click="openPrivacyPolicy" />
        <AveButton :darkmode="darkmode" icon="information" icon-type="normal" label="Credits" @click="openCredits" />
      </div>
    </div>
  </div>
</template>

<script>
import AveButton from '@/components/AveButton.vue';
// import AveInput from '@/components/AveInput.vue';

import db from '@/db';

export default {
  components: {
    AveButton,
    // AveInput,
  },

  computed: {
    type() {
      // console.log(`Config:${this.$store.state.hideFinishedTodos}`);
      return this.$store.state.hideFinishedTodos;
    },
  },

  async created() {
    // if there is a done todo in database, enable buttons
    try {
      const count = await db.todos.where('done').equals(1).count();
      if (count > 0) {
        this.disabled = false;
      }
    } catch (err) {
      console.warn(`Error looking for done: ${err.message}`);
    }
  },

  data() {
    return {
      input: '',
      disabled: true,
    };
  },

  methods: {
    handleHide() {
      if (this.$store.state.hideFinishedTodos) {
        this.$store.dispatch('toggleHideFinishedTodos', false);
        // console.log('show');
      } else {
        this.$store.dispatch('toggleHideFinishedTodos', true);
      }
    },

    handleDelete() {
      // starting a toasty before delting
      this.$store.commit('addToasty', {
        // action prop to delete all done todos
        action: async () => {
          // console.log('Deleted all done todos');
          try {
            // deleting todos in database that are done === 1
            await db.todos.where('done').equals(1).delete();
          } catch (err) {
            console.warn(`Error deleting all todos marked as done: ${err.message}`);
          }
          this.$store.commit('closeToasty', this.$store.state.toasties[this.$store.state.toasties.length - 1].id);
        },
        labelClose: 'No!',
        labelConfirm: 'Yes!',
        iconClose: 'wrong',
        iconConfirm: 'done',
        text: 'You are about to delete all you\'re finished To Dos. All that data will be lost. Do you really want to proceed?',
      });
    },

    openChangeLog() {
      this.$store.commit('addToasty', {
        action: () => {
          this.$store.commit('closeToasty', this.$store.state.toasties[this.$store.state.toasties.length - 1].id);
        },
        labelClose: 'Close',
        iconClose: 'done',
        text: 'This is supposed to be a changelog, but until now it\'s just Lorem ipsum... Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
      });
    },

    openPrivacyPolicy() {
      this.$store.commit('addToasty', {
        action: () => {
          this.$store.commit('closeToasty', this.$store.state.toasties[this.$store.state.toasties.length - 1].id);
        },
        labelClose: 'Close',
        iconClose: 'done',
        text: 'This is supposed to be the privacy policy, but until now it\'s just Lorem ipsum... Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
      });
    },

    openCredits() {
      this.$store.commit('addToasty', {
        action: () => {
          this.$store.commit('closeToasty', this.$store.state.toasties[this.$store.state.toasties.length - 1].id);
        },
        labelClose: 'Close',
        iconClose: 'done',
        text: 'This is supposed to be the credits, but until now it\'s just Lorem ipsum... Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
      });
    },


  },

  props: {
    errorType: String,
    darkmode: Boolean,
  },

};
</script>

<style lang="stylus" scoped>
@require '../assets/styles/colors.styl'
@require '../assets/styles/styles.styl'
@require '../assets/styles/base.styl'

.config
  overflow-y scroll


.innerBox
  color #434343
  position absolute
  top 0
  left 50%
  transform translateX(-50%)
  width $innerBoxWidth
  height auto
  margin-top $marginTop
  margin-bottom $navHeight
  border-color $normal
  border $borderBoxes
  box-shadow $shadow
  border-radius $radiusBoxes

  &.dark
    color: $darkmodeWhite
    margin-top 100px

.contentWrapper
  width $contentWrapperWidth
  padding-top $marginBottom
  padding-bottom $marginBottom
  margin auto

</style>
